import { render, staticRenderFns } from "./MasaderTab.vue?vue&type=template&id=082a157e"
import script from "./MasaderTab.vue?vue&type=script&lang=js"
export * from "./MasaderTab.vue?vue&type=script&lang=js"
import style0 from "./MasaderTab.vue?vue&type=style&index=0&id=082a157e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports